var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    fill: "#A79378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.89 13.113V8.666a.446.446 0 0 0-.443-.444H8.666a.443.443 0 0 0-.444.444.444.444 0 0 0 .444.444.443.443 0 0 1 .443.444v3.559a.444.444 0 0 1-.443.444.443.443 0 0 0 0 .887h2.668a.443.443 0 0 0 0-.887.443.443 0 0 1-.443-.444Z",
    fill: "url(#Info_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.351 13.557a.454.454 0 0 1-.318-.13.44.44 0 0 1-.132-.314V8.666a.439.439 0 0 0-.278-.41.457.457 0 0 0-.172-.034H10a5.46 5.46 0 0 1 0 .888v5.335h1.327c.12 0 .234-.047.319-.13a.44.44 0 0 0 .008-.62.453.453 0 0 0-.303-.138Z",
    fill: "url(#Info_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.008 5.556h-.016a.881.881 0 0 0-.88.88v.016c0 .487.393.881.88.881h.016a.881.881 0 0 0 .88-.88v-.016a.881.881 0 0 0-.88-.881Z",
    fill: "url(#Info_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Info_svg__a",
    x1: 10.004,
    y1: 10.687,
    x2: 10.004,
    y2: -5.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA1BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Info_svg__b",
    x1: 75.973,
    y1: 54.267,
    x2: 75.973,
    y2: 159.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA1BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Info_svg__c",
    x1: 51.682,
    y1: -24.131,
    x2: 51.682,
    y2: -41.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA1BB"
  })))));
};
export default SvgInfo;